import React from 'react';
import imtLogoWhite from '../../assets/images/IMT_logo.png';
import './KYCPortal.css';

/**
 * Shared chrome for every KYC portal screen: IMT-branded gradient header,
 * neutral page background, footer. Partner-facing but visually identical to
 * the internal IMT product family.
 */
const KYCPortalShell = ({ children, headerRight = null, subtitle = 'Partner Onboarding Portal' }) => (
    <div className="kyc-portal">
        <header className="kyc-portal-header">
            <div className="kyc-portal-header-left">
                <img src={imtLogoWhite} alt="IMT" className="kyc-portal-logo" />
                <div>
                    <h1 className="kyc-portal-header-title">IMT KYC Portal</h1>
                    <p className="kyc-portal-header-sub">{subtitle}</p>
                </div>
            </div>
            {headerRight && <div className="kyc-portal-header-right">{headerRight}</div>}
        </header>
        {children}
        <footer className="kyc-portal-footer">
            IMT International Minerals Trading AG · Secure KYC onboarding · Your documents
            are transmitted encrypted and reviewed only by the IMT compliance team.
        </footer>
    </div>
);

export default KYCPortalShell;
